import { useRouter } from 'next/router'
import { useMemo } from 'react'

export const useStringQuery = (): Record<string, string> => {
  const router = useRouter()

  return useMemo(() => {
    const stringQuery: Record<string, string> = {}

    Object.entries(router.query).forEach(([key, value]) => {
      if (value !== undefined) {
        stringQuery[key] = Array.isArray(value) ? value[0] : value
      }
    })

    return stringQuery
  }, [router.query])
}
